export class Page {

  private nome:   string;
  private botao:  string;
  private tipo:   string;
  private pagPai: string;

  constructor(nome, botao, tipo, pagPai) {
    this.nome   = nome;
    this.botao  = botao;
    this.tipo   = tipo;
    this.pagPai = pagPai;
  }

  public toJSON() {
    return {
      nome:   this.nome,
      botao:  this.botao,
      tipo:   this.tipo,
      pagPai: this.pagPai
    };
}

}
